import { FilterSearchPayload } from "@/app/home/components/table/DataTable";
import { FactoryBillingRepo } from "@/core/repos/tables/factory-billing.repo";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import container from "@/lib/di/container";
import { Button, message, Modal, Progress } from "antd";
import { useState, useEffect, Dispatch, SetStateAction } from "react";

const factoryBillingRepo = container.get(FactoryBillingRepo);
const waterInvoiceRepo = container.get(WaterInvoiceRepo);
interface SMSModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: {
        total: number,
        filterMap: Map<string, FilterSearchPayload>
    }
}
export const SMSModal: React.FC<SMSModalProps> = ({ isModalOpen, setIsModalOpen, data }) => {
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const [loading, setLoading] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<string>('');
    const [processed, setProcessed] = useState<number>(0);
    const process = async () => {
        if (confirm !== data.total.toString()) {
            message.error("Số lượng nhập không khớp");
            return;
        }
        const factoryBilling = await factoryBillingRepo.GetByWaterFactory();
        if (!factoryBilling?.parameter) {
            message.error("Chưa cấu hình thông báo số nước cho nhà máy");
            return;
        }
        const config = JSON.parse(factoryBilling.parameter);
        if (!config.SmsGateway || !config.SMSTemplateId) {
            message.error("Đơn vị chưa được cấu hình dịch vụ SMS");
            return;
        }
        const pageSize = 10;
        const totalPage = Math.ceil(data.total / pageSize);
        const query: any = {};
        data.filterMap.forEach(filter => {
            if (filter.value) {
                query[filter.key] = filter.value
            }
        })
        let _smsSendSuccess = 0;
        let _processed = 0;
        for (let page = 0; page < totalPage; page++) {
            if (!isModalOpen) {
                break;
            }
            const dataInvoice = await waterInvoiceRepo.getData(page, query, pageSize);
            if (!dataInvoice) {
                break;
            }
            const smsWaterInvoice = dataInvoice.data.filter(x => !x.sendDate);
            for (let wi = 0; wi < smsWaterInvoice.length; wi++) {
                const invoice = smsWaterInvoice[wi];
                if (!isModalOpen) {
                    return;
                }
                const response = await waterInvoiceRepo.SendSMSAsync({
                    Data: invoice,
                    SmsGateway: config.SmsGateway,
                    TemplateId: config.SMSTemplateId
                });
                if (response) {
                    _smsSendSuccess++;
                }
                _processed++;
                setProcessed(_processed);
            }
        }
        if (_smsSendSuccess > 0) {
            message.success(`Đã gửi thành công ${_smsSendSuccess}/${_processed} SMS`);
        }

    }
    const handleSave = async () => {
        setLoading(true);
        await process();
        setIsModalOpen(false);
        setLoading(false);
    }
    return <Modal open={isModalOpen} onCancel={handleCancel} width={600}
        style={{
            top: 20
        }}
        styles={{
            mask: {
                backdropFilter: 'blur(2px)',
                backgroundColor: 'var(--primary-mask)'
            }
        }}
        footer={[
            <div key={1} className="w-full flex flex-row justify-end px-1.5">
                <Button key="submit" type="primary" loading={loading}
                    style={{
                        background: "var(--primary-color)",
                        paddingRight: 48,
                        paddingLeft: 48,
                        fontSize: 18,
                        fontWeight: 600,
                        paddingTop: 18,
                        paddingBottom: 18,
                    }} onClick={handleSave} >
                    Xác nhận
                </Button>
            </div>,
        ]}
    >
        <div className="flex flex-row w-full items-start justify-start select-none">
            <p className="ml-6 text-2xl font-bold text-primary">Xác nhận gửi SMS</p>
        </div>
        <div className="flex flex-col items-center">
            <div className="py-4 px-4 w-full">
                <div>Có <b>{data.total}</b> khách hàng chưa gửi thông báo số nước.</div>

                <div>Bạn có chắc chắn muốn gửi SMS thông báo số nước tháng <b>{`${data.filterMap.get("month")?.value}-${data.filterMap.get("year")?.value}`}</b> đến <b>{data.total}</b> khách hàng?</div>

                <div>Nhập số <b>{data.total}</b> để xác nhận hành động</div>
                <div>
                    <input type="text" className="border border-primary rounded-md w-full p-2" value={confirm} onChange={e => setConfirm(e.target.value)} />
                </div>
                {(loading || processed > 0) && <div>
                    <div className="text-danger text-lg font-bold mt-4 ">
                        Không tắt trang hoặc cửa sổ này trong quá trình xử lý
                    </div>
                    <Progress percent={processed / data.total * 100} status="active"
                        format={() => `Đang xử lý ${processed} / ${data.total} sms`}
                    />
                </div>}
            </div>
        </div>
    </Modal>
} 